import React from 'react'
import { navigate } from '@reach/router'

const GrandCentral = () => {
  const slug = window.location.pathname.slice(1)
  const isLambda = slug.indexOf('.netlify') > -1
  if (slug && !isLambda) {
    fetch(`/.netlify/functions/getShortUrl?slug=${slug}`)
      .then(response => response.json())
      .then(response => {
        if (response && response.url) {
          navigate(response.url)
        } else {
          console.log('OTHER ELSE')
          navigate('/chiquito')
        }
      })
  } else {
    navigate('/chiquito')
  }

  return (
    <div>
      Finding the Right Place to Send You...
    </div>
  )
}

export default GrandCentral



// WEBPACK FOOTER //
// ./src/pages/GrandCentral.jsx